module.exports = __webpack_public_path__ + "static/phone-a4dc037d83577deee4ce4d6a40666aa2.jpg";